import { takeLeading, put, call, select } from "redux-saga/effects";
import { TResult, isLoaded, TLoadable } from "../../../../sg-core";
import {
    IRequestFetchSaveObservationProcessForm,
    createSuccessFetchSaveObservationProcessFormAction,
    createFailureFetchSaveObservationProcessFormAction,
    requestSaveObservationProcessForm,
} from "../actions/observationActions";

import IObservation from "../../interfaces/IObservation";
import { IObservationService } from "../../services/observationService";
import { selectCurrentObservation, selectObservationProcessForm } from "../selectors/observationSelectors";
import { createRequestFetchObservationPageAction } from "../actions/observationListActions";
import { selectLoggedInUserId } from "../../auth/store/authSelectors";
import ClassificationTextMapper from "../../mappers/ClassificationTextMapper";

const makeFetchSaveObservationProcessFormSaga = (observationService: IObservationService) =>
    function* saga(action: IRequestFetchSaveObservationProcessForm) {
        const currentObservation: TLoadable<IObservation> = yield select(selectCurrentObservation);
        //@ts-ignore
        const processForm = yield select(selectObservationProcessForm);
        const customFormSchema = action.payload.customFormSchema;
        const userId: number | null = yield select(selectLoggedInUserId);

        if (!currentObservation || !isLoaded(currentObservation)) {
            yield put(createFailureFetchSaveObservationProcessFormAction(Error("Observation is not loaded!!")));
            return
        }

        const currentMarkings = currentObservation.data.formData.merkinnat;

        const newMarking = {
            ...processForm.data,
            creator: userId
        }


        const observationWithNewProcessForm: IObservation = {
            ...currentObservation.data,
            is_public: processForm.data.formData.on_julkinen,
            processingFormSchema: customFormSchema ? customFormSchema : currentObservation.data.processingFormSchema,
            classificationText: newMarking.formData.luokitteluteksti && customFormSchema ? ClassificationTextMapper.valueToText(newMarking.formData.luokitteluteksti, customFormSchema) : "",

            formData: {
                ...currentObservation.data.formData,
                tila: newMarking.formData.tila,
                merkinnat: [
                    ...(currentMarkings || []),
                    newMarking
                ]
            }
        }

        try {
            const saveResult: TResult<{ observation: IObservation }> = yield call(observationService.saveObservation, observationWithNewProcessForm);

            if (saveResult.isSuccess) {
                yield put(createSuccessFetchSaveObservationProcessFormAction(saveResult.value.observation));

                //const filters = yield select(selectObservationFilters);
                yield put(createRequestFetchObservationPageAction());

            } else {
                yield put(createFailureFetchSaveObservationProcessFormAction(saveResult.isFailure ? saveResult.error : new Error()));
            }
        } catch (e) {
            yield put(createFailureFetchSaveObservationProcessFormAction(e as Error));
        }

    };
export default function create(observationService: IObservationService) {
    return takeLeading(
        requestSaveObservationProcessForm,
        makeFetchSaveObservationProcessFormSaga(observationService),
    );
}
